import { render, staticRenderFns } from "./VoiceBlast.vue?vue&type=template&id=79480257"
import script from "./VoiceBlast.vue?vue&type=script&lang=js"
export * from "./VoiceBlast.vue?vue&type=script&lang=js"
import style0 from "./VoiceBlast.vue?vue&type=style&index=0&id=79480257&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports